<template>
    <b-tab :title="$store.state.localization.data.mainPage.fuelTankCard.waterLevelSensorTabLabel">
      <b-form-checkbox v-model="sensorEnabled" switch>
        {{ $store.state.localization.data.mainPage.fuelTankCard.waterLevelSensorEnabledLabel }}
      </b-form-checkbox>
      <b-form-group
        label-cols-sm="9"
        label-cols-lg="9"
        content-cols-sm
        content-cols-lg="9"
        :label="$store.state.localization.data.mainPage.fuelTankCard.waterLevelSensorInputLabel"
        label-for="input-horizontal"
      >
      <b-form-select
        v-model="sensorInput"
        style="font-size: 13px"
        :disabled="!sensorEnabled"
        :options="sensorInputs"
      ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="7"
        label-cols-lg="7"
        content-cols-sm
        content-cols-lg="7"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelLevelCorrectionLabel"
        label-for="input-horizontal"
      >
      <b-form-input
        type="number"
        min="-9999999999"
        max="9999999999"
        :readonly="
          $store.state.authentication.roles.indexOf(
            ADMIN_ROLE
          ) == -1
        "
        v-model="fuelTankCard.waterLevelCorrection"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
     
    </b-tab>
  </template>

<script>
import { roleService } from "../../../services";

export default {
  name: "WaterLevelSensorTab",
  props: {
    fuelTankCard: Object,
  },
  data() {
    return {
      sensorEnabled: false,
      sensorInput: 0,
      ADMIN_ROLE: roleService.ADMIN_ROLE
    };
  },
  computed: {
    sensorInputs() {
      const options = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .waterLevelSensorInputsDropdown.length;
        i++
      ) {
        options.push({
          value: i,
          text: this.$store.state.localization.data.mainPage.fuelTankCard
            .waterLevelSensorInputsDropdown[i],
        });
      }
      return options;
    },
  },
  created() {
    if (!this.fuelTankCard.waterSensorInput) {
      return;
    }

    this.sensorEnabled = true;

    for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .waterLevelSensorInputsDropdown.length;
        i++
      ) {

        if (this.$store.state.localization.data.mainPage.fuelTankCard
            .waterLevelSensorInputsDropdown[i] == this.fuelTankCard.waterSensorInput) {
              this.sensorInput = i;
              break;

        }
      }
  },
  methods: {
    getSensorSettings() {
      if (this.sensorEnabled) {
        return {
          sensorEnabled: this.sensorEnabled,
          sensorInput: this.$store.state.localization.data.mainPage.fuelTankCard
              .waterLevelSensorInputsDropdown[this.sensorInput]
        }
      } else {
        return {
          sensorEnabled: this.sensorEnabled,
          sensorInput: null
        }
      }
    },
  },
};
</script>

